import { SxProps } from "@mui/material";

const ButtonProps: SxProps = {
  minWidth: "80px",
  height: "40px",
  boxShadow: "0 2px 6px var(--shadow-sm-overlay)",
  fontSize: "25px",
  fontWeight: "medium",
  color: "var(--gray-700)",
  py: "20px",
  bgcolor: "var(--white)",
  borderColor: "var(--gray-250)",
  borderWidth: "3px",
  borderRadius: "10px",
  ":hover": {
    backgroundColor: "var(--gray-250)",
    boxShadow: "var(--shadow)",
    borderColor: "var(--gray-250)",
    borderWidth: "3px",
  },
};

const UpdateBtnSxProps: SxProps = {
  backgroundColor: "var(--gray-500)",
  color: "var(--white)",
  width: "240px",
  height: "full",
  fontSize: "25px",
  borderRadius: "8px",
  fontWeight: "medium",
  ":hover": {
    backgroundColor: "var(--gray-250)",
    boxShadow: "var(--shadow)",
  },
};

const DeleteBtnSxProps: SxProps = {
  bgcolor: "red",
  width: "100px",
  height: "100%",
  fontSize: "25px",
  ":hover": { backgroundColor: "var(--red-700)" },
};

const ModalSxProps: SxProps = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90vh",
  overflow: "auto",
  width: "80%",
  maxWidth: "870px",
  backgroundColor: "var(--white)",
  border: "3px solid var(--gray-250)",
  padding: "30px 70px",
  borderRadius: "21px",
};

const labelProps: SxProps = {
  fontWeight: "bold",
  fontSize: { xs: 16, md: 18, lg: 20 },
  color: "var(--black)",
  lineHeight: "48px",
  height: "48px",
  padding: "0 0 0 40px",
  bgcolor: "var(--primary-500)",
  borderRadius: 0,
  minWidth: { md: "302px", xs: "180px" },
  width: { md: "302px", xs: "180px" },
};

export { ButtonProps, ModalSxProps, UpdateBtnSxProps, labelProps, DeleteBtnSxProps };
